import { animate, style, transition, trigger } from '@angular/animations';

const initialDelayMs = 500;
const oldValueShiftDurationMs = 500;
const newValueDelayMs = 0;
const newValueScaleDurationMs = 500;

export const tokenBoostAnimations = [
    trigger('oldValueAnimation', [
        transition(valueChanged, [
            style({ 'transform': 'translateX(140%)', 'opacity': '1', 'text-decoration': 'none' }),
            animate(`${oldValueShiftDurationMs}ms ${initialDelayMs}ms cubic-bezier(.03,1.06,.48,1)`),
        ]),
    ]),
    trigger('newValueAnimation', [
        transition(valueChanged, [
            style({ transform: 'scale(0)' }),
            animate(`${newValueScaleDurationMs}ms ${oldValueShiftDurationMs + initialDelayMs + newValueDelayMs}ms cubic-bezier(.7,1.57,1,1)`),
        ]),
    ]),
];

export const valueSelectors = '@oldValueAnimation, @newValueAnimation';

export function valueChanged(previousValue: string | null, newValue: string | null): boolean {
    return !!newValue && newValue !== 'void' && previousValue !== newValue;
}
